module.exports = __webpack_public_path__ + "static/media/emergency.809896af.mp3";